const MEDIA = [
  {
    title: '顶流明星专访：回应近期所有争议',
    duration: '15:28',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20interview%20setting%20with%20dramatic%20lighting%20and%20velvet%20backdrop%2C%20warm%20golden%20and%20coral%20tones%2C%20professional%20video%20production%20atmosphere%2C%20film%20set%20style%2C%20no%20people%2C%20editorial%20photography&width=500&height=320&seq=media-01-2026&orientation=landscape',
    tag: '专访',
  },
  {
    title: '年度吃瓜大事件回顾：精彩瞬间全收录',
    duration: '22:15',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20video%20montage%20concept%20with%20overlapping%20colorful%20frames%2C%20warm%20vibrant%20colors%2C%20entertainment%20news%20collage%20style%2C%20modern%20media%20art%2C%20editorial%20design%2C%20no%20text%20no%20people&width=500&height=320&seq=media-02-2026&orientation=landscape',
    tag: '盘点',
  },
  {
    title: '网红经济背后：MCN的运作内幕',
    duration: '18:42',
    views: '87万',
    img: 'https://readdy.ai/api/search-image?query=A%20behind%20the%20scenes%20documentary%20style%20shot%20of%20a%20creative%20workspace%20with%20cameras%20and%20monitors%2C%20warm%20ambient%20lighting%2C%20investigative%20journalism%20mood%2C%20editorial%20photography%2C%20no%20people&width=500&height=320&seq=media-03-2026&orientation=landscape',
    tag: '纪录片',
  },
  {
    title: '海外吃瓜速递：全球娱乐圈一周热点',
    duration: '12:08',
    views: '74万',
    img: 'https://readdy.ai/api/search-image?query=A%20global%20entertainment%20news%20concept%20with%20world%20map%20and%20floating%20headline%20bubbles%20in%20different%20colors%2C%20warm%20teal%20and%20coral%20gradient%2C%20modern%20broadcast%20design%2C%20editorial%20style%2C%20no%20text%20no%20people&width=500&height=320&seq=media-04-2026&orientation=landscape',
    tag: '速递',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            吃瓜视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            51吃瓜网站精选视频内容，吃瓜不止于文字，更有精彩影像
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {MEDIA.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group bg-background-50 rounded-xl overflow-hidden transition-all duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
                    <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                  </span>
                </div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-white text-[10px] px-1.5 py-0.5 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[10px] font-semibold bg-accent-100 text-accent-700 px-1.5 py-0.5 rounded">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-2 font-heading group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.views} 次观看</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}